import axios, { AxiosInstance } from "axios";
import { useAuthStore } from "@/stores/authStore";

// Factory function to create API instance with custom base URL
const createApiInstance = (baseURL: string): AxiosInstance => {
    const instance = axios.create({
        baseURL,
        headers: {
            "Content-Type": "application/json",
        },
    });

    // Request interceptor to add auth token
    instance.interceptors.request.use((config) => {
            const { getToken } = useAuthStore.getState();
            const token = getToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

// Response interceptor to handle token refresh
    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;
            const { login, updateToken, getToken } = useAuthStore.getState();

            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;

                try {
                    await updateToken();

                    originalRequest.headers.Authorization = `Bearer ${getToken()}`;
                    return instance(originalRequest);

                } catch (refreshError) {
                    // If refresh token fails, redirect to login
                    login();
                    return Promise.reject(refreshError);
                }
            }

            return Promise.reject(error);
        }
    );

    return instance;
};

export { createApiInstance };